import "antd/es/space/style";
import _Space from "antd/es/space";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../typography';
import Button from '../button';
import './style';

var DefaultFooter = function DefaultFooter(props) {
  var hiddenIglooIcon = props.hiddenIglooIcon;
  var useBreakpoint = _Grid.useBreakpoint;

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  return md ? _jsx("div", {
    className: "igloo-layout-footer",
    children: _jsxs("div", {
      className: "footer-content",
      children: [!hiddenIglooIcon && _jsxs(_Fragment, {
        children: [_jsx(_Space, {
          size: 32,
          align: "start",
          className: "footer-top",
          children: _jsx("div", {
            className: "top-left",
            children: _jsx("div", {
              className: "igloo-logo"
            })
          })
        }), _jsx("div", {
          className: "footer-divider"
        })]
      }), _jsxs("div", {
        className: "footer-bottom",
        children: [_jsx(Typography, {
          level: "body3",
          children: "\xA9 ".concat(new Date().getFullYear(), " Powered by Axinan Pte Ltd. All Rights Reserved.")
        }), _jsxs(Typography, {
          level: "body3",
          children: [_jsx(Button, {
            type: "text",
            onClick: function onClick() {
              return window.open('https://contents.iglooinsure.com/privacypolicy');
            },
            children: _jsx(Typography, {
              level: "body3",
              children: "Privacy Policy"
            })
          }), ' ', _jsx("span", {
            style: {
              margin: '0px 16px'
            },
            children: "|"
          }), _jsx(Button, {
            type: "text",
            onClick: function onClick() {
              return window.open('https://contents.iglooinsure.com/termsofservice');
            },
            children: _jsx(Typography, {
              level: "body3",
              children: "Terms of Service"
            })
          })]
        })]
      })]
    })
  }) : _jsx("div", {
    className: "igloo-layout-footer",
    children: _jsxs("div", {
      className: "footer-content",
      children: [!hiddenIglooIcon && _jsx("div", {
        className: "igloo-logo"
      }), _jsxs("div", {
        className: "footer-bottom",
        children: [_jsx("div", {
          children: _jsxs(Typography, {
            level: "body3",
            children: ["\xA9 ".concat(new Date().getFullYear(), " Powered by Axinan Pte Ltd."), _jsx("div", {
              children: "All Rights Reserved."
            })]
          })
        }), _jsx("div", {
          children: _jsxs(Typography, {
            level: "body3",
            children: [_jsx(Button, {
              type: "text",
              onClick: function onClick() {
                return window.open('https://contents.iglooinsure.com/privacypolicy');
              },
              children: _jsx(Typography, {
                level: "body3",
                children: "Privacy Policy"
              })
            }), ' ', _jsx("span", {
              style: {
                margin: '0px 16px'
              },
              children: "|"
            }), ' ', _jsx(Button, {
              type: "text",
              onClick: function onClick() {
                return window.open('https://contents.iglooinsure.com/termsofservice');
              },
              children: _jsx(Typography, {
                level: "body3",
                children: "Terms of Service"
              })
            })]
          })
        })]
      })]
    })
  });
};

export default DefaultFooter;